// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".help-menu__btn{background-color:#382f3299;border-top-left-radius:4px;border-top-right-radius:4px;cursor:pointer;display:flex;transition:background-color .2s ease}@media(-ms-high-contrast:active),(-ms-high-contrast:none),(any-hover:hover){.help-menu__btn:focus,.help-menu__btn:hover{background-color:#382f32cc}}@media(any-hover:none){.help-menu__btn:active{background-color:#382f32cc}}@media(max-width:543px){.help-menu__btn{width:72px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
